
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.93 5.19a1.285 1.285 0 100-2.57 1.285 1.285 0 000 2.57z","fill":"#585858"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.862 0H5.138A5.138 5.138 0 000 5.138v2.724C0 10.7 2.3 13 5.138 13h2.724C10.7 13 13 10.7 13 7.862V5.138A5.138 5.138 0 007.862 0zM5.138.963h2.724a4.175 4.175 0 014.13 3.61h-.996a7.553 7.553 0 00-6.513 3.738A4.766 4.766 0 001.51 7.277H.963V5.138A4.181 4.181 0 015.138.963zM1.51 8.241H.983a4.175 4.175 0 002.485 3.442c.046-.857.24-1.7.572-2.492a3.854 3.854 0 00-2.53-.95zm6.353 3.796H5.138a3.86 3.86 0 01-.719-.071 6.59 6.59 0 016.577-6.442h1.04v2.338a4.182 4.182 0 01-4.174 4.175z","fill":"#585858"}})])
          )
        }
      }
    